import { facilityAction } from 'src/redux/actions/constant';
import { setFacilityId } from 'src/hooks/use-facility-id';

const {
  SWITCH_FACILITY_SUCCESS,
  SWITCH_FACILITY_FAILURE,
  SWITCH_FACILITY_RESET,
  SWITCH_FACILITY_LOADER,
} = facilityAction;

export const SwitchFacilityStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type SwitchFacilityStatusType =
  (typeof SwitchFacilityStatus)[keyof typeof SwitchFacilityStatus];

interface SwitchFacilityState {
  status: SwitchFacilityStatusType;
  response: any;
}

const intialFacilityState: SwitchFacilityState = {
  status: SwitchFacilityStatus.IDLE,
  response: null,
};

export const updateFacilityDropDownReducer = (state = intialFacilityState, action: any) => {
  switch (action.type) {
    case SWITCH_FACILITY_LOADER:
      return {
        ...state,
        status: SwitchFacilityStatus.LOADING,
      };

    case SWITCH_FACILITY_SUCCESS: {
      const getUpdatedFacilityId = String(action.payload.data.path).split('/');
      const facilityId = getUpdatedFacilityId[getUpdatedFacilityId.length - 1];
      setFacilityId(facilityId);
      return {
        ...state,
        status: SwitchFacilityStatus.SUCCESS,
        response: action.payload,
      };
    }

    case SWITCH_FACILITY_FAILURE:
      return {
        ...state,
        status: SwitchFacilityStatus.ERROR,
        response: action.payload,
      };

    case SWITCH_FACILITY_RESET:
      return intialFacilityState;

    default:
      return state;
  }
};
